export default __webpack_public_path__ + "static/heart-yellow-5308954f6187ed15d939ad46d885aa09.png";